import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { OrderHistory } from '../models';

export class HistoryState implements IStateSlice {
  public isLoading: boolean;
  public isSkeletonLoading: boolean;
  public failures: AppStateFailure;
  public orderHistory: OrderHistory;

  constructor() {
    this.isLoading = false;
    this.isSkeletonLoading = false;
    this.failures = null;
    this.orderHistory = null;
  }
}
